import React from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

// Components
import CategoryNavItem from '../CategoryNavItem';

// Icons
import PizzaData from './assets/menu/pizza.svg';
import NapitkiData from './assets/menu/drinks.svg';
import ZakuskiData from './assets/menu/snacks.svg';
import ComboboxData from './assets/menu/combobox.svg';
import DesertyData from './assets/menu/dessert.svg';
import SalatsData from './assets/menu/salads.svg';
import SousesData from './assets/menu/sauces.svg';
import OtherData from './assets/menu/other.svg';
import HotData from './assets/menu/hot.svg';
import PapadiasData from './assets/menu/papadias.svg';
import VeganData from './assets/menu/vegan.svg';
import Papiekanki from './assets/menu/papiekanki.svg';
import Toystory from './assets/menu/toystory.svg';

// Styles
import styles from './CategoryNavDesktop.styl';

const cx = classNames.bind(styles);

const iconsData = {
  pizza: PizzaData,
  napitki: NapitkiData,
  zakuski: ZakuskiData,
  salaty: SalatsData,
  deserty: DesertyData,
  sauce: SousesData,
  combo: ComboboxData,
  combobox: ComboboxData,
  other: OtherData,
  hot: HotData,
  papadias: PapadiasData,
  vegan: VeganData,
  papiekanki: Papiekanki,
  "toy-story": Toystory,
};

export default function CategoryNavDesktop(props) {
  const { className } = props;

  const categoriesAliases = useSelector(state => state.catalog.products.categoriesAliases);

  return (
    <div className={cx('CategoryNavDesktop', className)}>
      {Object.keys(categoriesAliases).map(alias => (
        <CategoryNavItem
          key={alias}
          className={cx('CategoryNavDesktop__link', `CategoryNavDesktop__link_${alias}`)}
          alias={alias}
          role="link"
          tabIndex="0"
        >
          <span className={cx('CategoryNavDesktop__iconWrap')}>
            <img
              className={cx('CategoryNavDesktop__icon', `CategoryNavDesktop__icon_${alias}`)}
              alt={alias}
              src={iconsData[alias] || iconsData.pizza}
            />
          </span>
          <span className={cx('CategoryNavDesktop__label')}>
            {categoriesAliases[alias]}
          </span>
        </CategoryNavItem>
      ))}
    </div>
  );
}

CategoryNavDesktop.defaultProps = {
  className: '',
};

CategoryNavDesktop.propTypes = {
  className: PropTypes.string,
};
